// @flow
const moment = require('moment')

const DATE_FORMAT = 'YYYY-MM-DD'
const FRIENDLY_DATE_FORMAT = 'D MMM YYYY'
const EXPIRY = 2
const PERIOD = 'days'

export const formatDate = (value: number) => {
  return moment(value).format(DATE_FORMAT)
}

export const formatDateFriendly = (value: string) => {
  return moment(value).format(FRIENDLY_DATE_FORMAT)
}

export const getEndDate = (value: number, membershipDuration: number) => {
  const date = moment(value)
  const endDate = date.add(membershipDuration, 'months').subtract(1, 'day')
  return endDate.format(DATE_FORMAT)
}

export const hasDateExpired = (date: number) => {
  if (!date) {
    return false
  }
  const created = moment.utc(Number(date))
  const expiry = moment.utc(Number(date)).add(EXPIRY, PERIOD)
  const dateNow = moment.utc(Date.now())
  return !dateNow.isBetween(created, expiry)
}



// WEBPACK FOOTER //
// ./src/helpers/dates.js